// Import orchestrators and mutators so they get registered
import './mutators/conversationsCategoriesStoreUpdateMutator';
import './mutators/itemsCategoriesStoreUpdateMutator';
import './mutators/flagItemsStoreUpdateMutator';
import './mutators/updateTableCurrentLoadedIndexMutator';
import './orchestrators/removeRowsFromListViewStoreOrchestrator';

import deleteConversationStoreUpdateStitch from './stitches/deleteConversationStoreUpdateStitch';
import deleteFolderInListViewStitch from './stitches/deleteFolderInListViewStitch';
import emptyFolderStitch from './stitches/emptyFolderStitch';
import markAllAsReadStitch from './stitches/markAllAsReadStitch';
import { runAfterBootstrap, runAfterInitialRender } from 'owa-delayed-initialization';
import { LazyModule, registerLazyOrchestrator } from 'owa-bundling';
import { removeSearchTableFromStore } from 'owa-mail-search';
import { onListViewTypeOptionSaved } from 'owa-options-actions/lib/onListViewTypeOptionSaved';
import markItemsAsReadStoreUpdate from 'owa-mail-actions/lib/triage/markItemsAsReadStoreUpdate';
import markItemsAsPinnedStoreUpdate from 'owa-mail-actions/lib/triage/markItemsAsPinnedStoreUpdate';
import markConversationsAsReadStoreUpdate from 'owa-mail-actions/lib/triage/markConversationsAsReadStoreUpdate';
import markConversationsAsPinnedStoreUpdate from 'owa-mail-actions/lib/triage/markConversationsAsPinnedStoreUpdate';
import { deleteItemsStoreUpdate } from 'owa-mail-actions';
import { onItemPartContextMenu } from 'owa-mail-actions/lib/mailListSelectionActions';

const lazyModule = new LazyModule(() => import(/* webpackPrefetch: true */ './lazyIndex'));

// Register lazy orchestrator
registerLazyOrchestrator(
    removeSearchTableFromStore,
    lazyModule,
    m => m.removeSearchTableFromStoreOrchestrator
);
registerLazyOrchestrator(
    onListViewTypeOptionSaved,
    lazyModule,
    m => m.onListViewTypeOptionSavedOrchestrator
);
registerLazyOrchestrator(
    markItemsAsReadStoreUpdate,
    lazyModule,
    m => m.markItemsAsReadStoreUpdateOrchestrator
);
registerLazyOrchestrator(
    markItemsAsPinnedStoreUpdate,
    lazyModule,
    m => m.markItemsAsPinnedStoreUpdateOrchestrator
);
registerLazyOrchestrator(
    markConversationsAsReadStoreUpdate,
    lazyModule,
    m => m.markConversationsAsReadStoreUpdateOrchestrator
);
registerLazyOrchestrator(
    markConversationsAsPinnedStoreUpdate,
    lazyModule,
    m => m.markConversationsAsPinnedStoreUpdateOrchestrator
);
registerLazyOrchestrator(
    deleteItemsStoreUpdate,
    lazyModule,
    m => m.deleteItemsStoreUpdateOrchestrator
);
registerLazyOrchestrator(
    onItemPartContextMenu,
    lazyModule,
    m => m.mailListItemExpansionOrchestrators
);

export { default as createMailFolderTableQuery } from './actions/createMailFolderTableQuery';
export {
    default as createMailCategoryFolderTableQuery,
} from './utils/createMailCategoryFolderTableQuery';
export { default as setRowOperation } from './actions/notifications/helpers/setRowOperation';
export { default as loadMoreInTable } from './actions/table/loadMoreInTable';
export { default as PropertyIcons } from './utils/conversationProperty/PropertyIcons';
export { default as getItemClassIcon } from './utils/conversationProperty/getItemClassIcon';
export { default as getPropertyIconStyle } from './utils/conversationProperty/getPropertyIconStyle';
export { default as getDefaultFocusedViewFilterForSelectedFolder } from './utils/FocusedInboxUtil';
export {
    default as getAllTableViewsContainingItemsForFolder,
} from './utils/getAllTableViewsContainingItemsForFolder';
export {
    default as getAllTableViewsContainingItems,
} from './utils/getAllTableViewsContainingItems';
export {
    default as getConversationSortByProperty,
} from './utils/tables/getConversationSortByProperty';
export { default as getMailItemSortByProperty } from './utils/tables/getMailItemSortByProperty';
export { default as reloadInboxPostBoot } from './actions/reloadInboxPostBoot';
export { default as loadInitialRowsFromServer } from './actions/table/loadInitialRowsFromServer';
export { default as onLoadInitialRowsSucceeded } from './actions/table/onLoadInitialRowsSucceeded';
export { default as removeTableFromStore } from './actions/store-factory/removeTableFromStore';
export {
    default as shouldUpdateFolderCount,
} from './actions/triage/helpers/shouldUpdateFolderCount';
runAfterBootstrap(() => {
    deleteConversationStoreUpdateStitch();
    emptyFolderStitch();
    markAllAsReadStitch();
});

runAfterInitialRender(() => {
    deleteFolderInListViewStitch();
});
